import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcBed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.25 10.747v-3.55a2.75 2.75 0 0 0-2.75-2.75h-11a2.75 2.75 0 0 0-2.75 2.75v3.55a2.75 2.75 0 0 0-1.5 2.45v6a.75.75 0 0 0 1.5 0v-2.25h16.5v2.25a.75.75 0 0 0 1.5 0v-6a2.75 2.75 0 0 0-1.5-2.45M6.5 5.947c-.69 0-1.25.56-1.25 1.25v3.25h13.5v-3.25c0-.69-.56-1.25-1.25-1.25zm13.75 9.5v-2.25c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v2.25z",
    clipRule: "evenodd"
  }));
}
var IcBed = createNolIcon(/*#__PURE__*/forwardRef(SvgIcBed));

export { IcBed as I };
